
import { TEAM_ADD_FORM } from "./teamAddConf";
import { sendRequest, API_ROOT } from "../../supplementary_components/requests";
import { addPopup, addNotification } from "../../supplementary_components/store";
import { ConfirmationDialogue } from "../../general_components/forms/ConfirmationDialogue";
import { Form } from "../../general_components/forms/Form";
import cloneDeep from "lodash/cloneDeep";
// import { EMPLOYEE_PAGE_OBJECT } from "./employeePageConf";

// Function to format phone and extension
// const combinePhoneWithExtension = (data) => {
//   let result = (data["directLine"] || "-") + ' / ' + (data["extension"] || "-");
//   return result;
// };

// Function to format first and last names
// const combineFullName = (data) => {
//   let result = data["firstName"] + ' ' + data["lastName"];
//   return result;
// };

export const TEAM_LISTING_CONF = {
    getRequestLink: API_ROOT+"teams",
    columnProportions: "1fr 1fr 1fr 3rem",
    dataTitle: "Team",
    dataTitlePlural:"Teams",
    addButton:true,
    addConf: TEAM_ADD_FORM,
    // pageConf: new EMPLOYEE_PAGE_OBJECT(),
    category: 'teams',
    editAccessLevel: { key: 'TEAMS', level: 'MANAGE' },
    columns :[
        {
            label: "Team Name",
            columnName: "teamName",
        },
        {
            label: "Team Members",
            columnName: "teamMembers",
            valueInterpreter: (value)=>{
                let allNames = "";
                for(const object of value){
                    allNames += `${object.firstName} ${object.lastName}, `;
                }
                return allNames.substr(0, allNames.length-2);
            },
        },
        {
            label: "Truck Count",
            columnName: "truckCount",
            sortable: true,
        },
        {
            actionButtons:true,
            notEditableIfValueIs : (val)=>{
                return val["teamName"].includes("(Solo Dispatch)");
            },
            onEditAction: (team, postSuccessAction)=>{
                const addFormClone = cloneDeep(TEAM_ADD_FORM);
                addFormClone.formTitle = "Edit Team"
                addFormClone.customSubmitButton = "Save Team"
                addFormClone.columns[0].defaultValue = ()=>{
                    return team.teamName;
                }
                addFormClone.columns[1].currentTeamId = team.id;
                addFormClone.columns[1].defaultValue = ()=>{
                    return team.teamMembers;
                }
                addFormClone.columns.unshift({
                    hiddenField:true,
                    name:"id",
                    defaultValue:()=>{
                        return team.id;
                    }
                });
                addPopup(
                    {
                        content:Form, 
                        popupData:{configuration: addFormClone}, 
                        postSuccessAction: ()=>{postSuccessAction()}, 
                        EZCloseAllowed:false
                    }
                )
            },
            onRemoveAction: (team, postSuccessAction)=>{
                addPopup({
                    content:ConfirmationDialogue, 
                    popupData: {
                        confirmationDialogue:true,
                        action:(postResultAction)=>{
                            sendRequest("DELETE", API_ROOT+`teams/${team.id}`, null, ()=>{
                                postSuccessAction();
                                postResultAction(true);
                            }, (e)=>{
                                addNotification({message:e.customError ? e.customError :`Something Went Wrong`, type:'alert'});
                                postResultAction(true);
                            } )
                        },
                        cancelAction:(closePopup)=>{
                            closePopup()
                        },
                        name:"Confirm",
                        formTitle:"Delete Team",
                        submitTitle:"Delete",
                        message:`Are you sure you want to delete team "${team.teamName}"?`
                    }, 
                    postSuccessAction: ()=>{
                        
                    }, 
                    EZCloseAllowed:false
                })
            }
        }
    ]
}